
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useCommunity } from '@/contexts/CommunityContext';
import { Plug } from 'lucide-react';
import StripeIntegrationSection from './StripeIntegrationSection';

const IntegrationsPage = () => {
  const { currentCommunity } = useCommunity();

  if (!currentCommunity?.id) {
    return (
      <div className="space-y-6 sm:space-y-8 animate-fade-in">
        <div className="relative">
          <h1 className="admin-section-title mb-2">Integrations</h1>
          <p className="text-muted-foreground/80 text-lg">
            Loading community information...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6 sm:space-y-8 animate-fade-in">
      <div className="relative">
        <h1 className="admin-section-title mb-2">Integrations</h1>
        <p className="text-muted-foreground/80 text-lg">
          Manage your community's third-party integrations and services
        </p>
      </div>
      
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h2 className="text-lg font-semibold text-slate-800">Available Integrations</h2>
          <p className="text-sm text-muted-foreground/80">Connect external services to enhance your community</p>
        </div>
      </div>

      <div className="space-y-6">
        <StripeIntegrationSection communityId={currentCommunity.id} />
        
        {/* Placeholder for future integrations */}
        <Card className="admin-card admin-card-stats">
          <CardHeader>
            <CardTitle className="text-lg font-semibold text-slate-800 flex items-center gap-2">
              <Plug className="h-5 w-5 text-purple-600" />
              More Integrations Coming Soon
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground/80 leading-relaxed">
              We're working on adding more integrations to help you manage your community better. 
              Stay tuned for updates on email marketing, analytics, and social media integrations!
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default IntegrationsPage;
